import { ButtonProps, useMultiStyleConfig } from '@chakra-ui/react';
import { type ReactNode } from 'react';
import { Link, LinkProps } from 'react-router';
import { Button } from '../../../../atoms';
import { useStatusCardRootContext } from '../root/status-card-context';

type StatusCardLinkProps = ButtonProps & LinkProps;

export function StatusCardLink(props: StatusCardLinkProps): ReactNode {
  const { variant } = useStatusCardRootContext();
  const styles = useMultiStyleConfig('StatusCard', { variant });

  return (
    <Button as={Link} variant="link" __css={styles.link} {...props}>
      {props.children}
    </Button>
  );
}
